import React from 'react';

const PaymentSummary = ({ subtotal, tax, totalDue }) => {
  return (
    <div className="flex justify-end mt-10">
      <div className="w-full md:w-1/2">
        <div className="bg-white p-6 rounded-xl">
          <div className="flex justify-between border-b py-2 text-gray-700">
            <span>Subtotal</span>
            <span id="subtotal" className="font-medium">${subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between border-b py-2 text-gray-700">
            <span>Tax (10%)</span>
            <span id="tax" className="font-medium">${tax.toFixed(2)}</span>
          </div>
          <div className="flex justify-between pt-4 text-xl font-bold text-gray-800">
            <span>Total Due</span>
            <span id="total-due">${totalDue.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;